import IComponentOptions = angular.IComponentOptions;
import IScope = angular.IScope;
import {TSMessageEvent} from '../../../../models/enums/TSErrorEvent';
import ErrorService from '../../service/ErrorService';
import TSExceptionReport from '../../../../models/TSExceptionReport';
import {TSErrorLevel} from '../../../../models/enums/TSErrorLevel';

let templ = require('./dvb-error-messages-panel.html');
let style = require('./dvb-error-messages-panel.scss');

export class DvErrorMessagesPanelComponentConfig implements IComponentOptions {

    scope = {};
    template = templ;
    controller = DvErrorMessagesPanelComponent;
    controllerAs = 'vm';
}

/**
 * component that can display error messages
 */
export class DvErrorMessagesPanelComponent {

    errors: Array<TSExceptionReport> = [];
    static classprefix: string = 'dvb-error-messages-panel';

    static $inject: string[] = ['$scope', 'ErrorService'];
    /* @ngInject */
    constructor(private $scope: IScope, private errorService: ErrorService) {
    }

    $onInit() {
        this.$scope.$on(TSMessageEvent[TSMessageEvent.ERROR_UPDATE], this.displayMessages);
        this.$scope.$on(TSMessageEvent[TSMessageEvent.INFO_UPDATE], this.displayMessages);
        this.$scope.$on(TSMessageEvent[TSMessageEvent.CLEAR], () => {
            this.errors = [];
        });
    }

    displayMessages = (event: any, errors: Array<TSExceptionReport>) => {
        this.errors = errors;
        this.show();
    };

    show() {
        // this.element.show();
        angular.element('dvb-error-messages-panel').show();     //besser als $element injection fuer tests
    }

    clear() {
        this.errorService.clearAll();
    };

    messageStyle(): string {
        let returnClass: string = '';
        for (let error of this.errors) {
            switch (error.severity) {
                case TSErrorLevel.INFO:
                    returnClass = DvErrorMessagesPanelComponent.classprefix + '--info';
                    break;
                case TSErrorLevel.WARNING:
                    returnClass = DvErrorMessagesPanelComponent.classprefix + '--warning';
                    break;
                case TSErrorLevel.SEVERE:
                    returnClass = DvErrorMessagesPanelComponent.classprefix + '--danger';
                    break;
            }
        }
        return returnClass;
    }

}





// WEBPACK FOOTER //
// ./src/app/core/errors/directive/dvb-error-messages/dvb-error-messages-panel.ts